module.exports = __webpack_public_path__ + "static/media/omocestus_rufipes_003_APA.0d5747cd.png";